import { Injectable } from '@angular/core';

@Injectable()
export class DeviceService {
  constructor() {}

  public isMobile() {
    return window.innerWidth < 768;
  }

  public isTablet() {
    return window.innerWidth >= 768 && (<any>window).innerWidth < 1152;
  }

  public isDesktop() {
    return window.innerWidth >= 1152;
  }

  public getDeviceString() {
    return this.isMobile() ? 'mobile' : this.isDesktop() ? 'desktop' : 'tablet';
  }
}
